import React from 'react';
import PropTypes from 'prop-types';

const ChatHeader = ({ inputTokens, outputTokens }) => (
  <div>
    <p>
      {'Input Tokens: '}
      {inputTokens}
      {' | Output Tokens: '}
      {outputTokens}
    </p>
  </div>
);

ChatHeader.propTypes = {
  inputTokens: PropTypes.number.isRequired,
  outputTokens: PropTypes.number.isRequired,
};

export default ChatHeader;
